import {CoreActions, CoreActionTypes} from '../actions/core.actions';
import {OrganizationWithToken} from '../models/core';

export interface State {
  selectedOrganization: OrganizationWithToken | null;
  selectedOrganizationError: string;
}

export const initialState: State = {
  selectedOrganization: JSON.parse(localStorage.getItem('selected_organization')) || null,
  selectedOrganizationError: null
};

export function reducer(state = initialState, action: CoreActions): State {
  switch (action.type) {

    case CoreActionTypes.SelectOrganization: {
      return {
        ...state,
        selectedOrganizationError: null
      };
    }

    case CoreActionTypes.SelectOrganizationSuccess: {
      const selectedOrganizationWithToken: OrganizationWithToken = action.payload;
      return {
        ...state,
        selectedOrganization: selectedOrganizationWithToken
      };
    }

    case CoreActionTypes.SelectOrganizationFail: {
      const errorMessage: string = action.payload;
      return {
        ...state,
        selectedOrganization: null,
        selectedOrganizationError: errorMessage
      };
    }

    default:
      return state;
  }
}

export const selectedOrganization = (state: State) => state.selectedOrganization;
export const selectedOrganizationError = (state: State) => state.selectedOrganizationError;
